import Vue from 'vue'
import Moment from 'moment';
import  translate from './../utils/translation'

Vue.filter('date', function(value) {
  return Moment(value).format("DD-MM-YYYY");
});

Vue.filter('percentage', function(value) {
  return value + ' %';
});

Vue.filter('translate', function(value) {
  return translate.translate(value);
});


Vue.filter('amountFormat', function(value) {
  return parseFloat(value).toFixed(2);
});


// WEBPACK FOOTER //
// ./src/config/filters.js